import React from 'react'
import { SectionHeader } from '../../../../component'
import { DueTodaySection } from './DueTodaySection'
import { PaylaterSection } from './PaylaterSection'
import { useTranslation } from '../../../../utils/convergence'
import { ChargeAtShipMessage } from './ChargeAtShipMessage'

export const Summary = (): JSX.Element => {
  const { t } = useTranslation()

  return (
    <>
      <SectionHeader title={t('summary:summary')} />
      <PaylaterSection />
      <DueTodaySection />
      <ChargeAtShipMessage />
    </>
  )
}
